export class Helper {

    public static isStringNullOrEmpty(string?: string): boolean {
        return (string === undefined || string === null || string === '');
    }

    public static isArrayNullOrEmpty(array?: any[]): boolean {
        return array == null || array.length == 0;
    }

    public static isObject(value?: any): boolean {
        return value != null && typeof value == "object";
    }

    public static isObjectEmpty(obj: { [key: string]: any }): boolean {
        return Object.keys(obj).length == 0;
    }

    public static isNumeric(numString: number | string): boolean {
        let numStringType = typeof numString;
        if (numStringType != "string") {
            return (numStringType === "number");
        }
        else {
            return !isNaN(<number>numString) && !isNaN(parseFloat(<string>numString));
        }
    }

    public static isNumberPositive(numberValue: number, allowZero: boolean = false): boolean {
        return numberValue > 0 || (allowZero && numberValue == 0);
    }

    public static isNullOrValue<T>(item: T, value: T): boolean {
        return item == null || item == value;
    }

    public static defaultIfNull<T>(value: T, defaultValue: T): T {
        return value != null ? value : defaultValue;
    }

    public static getTimestampFromDate(date: Date, separator: string = ""): string {
        let { year, month, day } = this.getParsedDate(date);
        let { hours, minutes, seconds, milliseconds } = this.getParsedTime(date);

        return [year, month, day, hours, minutes, seconds, milliseconds].join(separator);
    }

    public static getDateTimeString(date: Date): string {
        let { year, month, day } = this.getParsedDate(date);
        let { hours, minutes, seconds, milliseconds } = this.getParsedTime(date);

        return [year, month, day].join("-") + "T" + [hours, minutes, seconds].join(":") + "." + milliseconds;
    }

    public static getParsedDate(date: Date) {
        let year = this.getPaddedNumberString(date.getFullYear(), 4);
        let month = this.getPaddedNumberString(date.getMonth() + 1);
        let day = this.getPaddedNumberString(date.getDate());

        return {
            year, month, day
        };
    }

    public static getParsedTime(date: Date) {
        let hours = this.getPaddedNumberString(date.getHours());
        let minutes = this.getPaddedNumberString(date.getMinutes());

        let seconds = this.getPaddedNumberString(date.getSeconds());
        let milliseconds = this.getPaddedNumberString(date.getMilliseconds(), 3);

        return {
            hours, minutes, seconds, milliseconds
        };
    }

    public static removeNumberPadding(number: string): string {
        var displayValue = number;
        if (number.startsWith("0")) {
            displayValue = number.substring(1);
        }

        return displayValue;
    }

    public static getPaddedNumberString(num: number, numOfDigits: number = 2): string {
        let paddedNumberString = "";

        let paddedNumber = num / Math.pow(10, numOfDigits);
        let paddedNumberSplit = paddedNumber.toString().split(".");
        if (paddedNumberSplit.length > 1) {
            paddedNumberString = paddedNumberSplit[1];

            let digitsRemaining = numOfDigits - paddedNumberString.length;
            if (digitsRemaining != 0) {
                paddedNumberString += this.getZeroPaddedString(digitsRemaining);
            }
        } else {
            paddedNumberString = this.getZeroPaddedString(numOfDigits);
        }

        return paddedNumberString;
    }

    public static addToDate(date: Date, data: { days?: number, months?: number, years?: number }): Date {
        var currentDate = new Date(date.valueOf());

        if (data.days != null) {
            currentDate.setDate(currentDate.getDate() + data.days);
        }

        if (data.months != null) {
            currentDate.setMonth(currentDate.getMonth() + data.months);
        }

        if (data.years != null) {
            currentDate.setFullYear(currentDate.getFullYear() + data.years);
        }

        return currentDate;
    };

    public static getZeroPaddedString(numOfZeros: number): string {
        let zeroPaddedString = "";

        let zeroPaddingArray = new Array(numOfZeros);
        for (let i = 0; i < zeroPaddingArray.length; i++) {
            zeroPaddedString += "0";
        }

        return zeroPaddedString;
    }

    // flexible password generator (non-crypto)
    public static generatePassword(length = 12, {
        lowercase = { include: true, guarantee: false },
        uppercase = { include: true, guarantee: false },
        numbers = { include: true, guarantee: false },
        symbols = { include: false, guarantee: false },
    } = {}) {
        const sets = {
            lowercase: "abcdefghijklmnopqrstuvwxyz",
            uppercase: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
            numbers: "0123456789",
            symbols: "!@#$%^&*()-_=+[]{};:,.?/\\|~",
        };

        // Build character pool
        let alphabet = "";
        for (const [key, { include }] of Object.entries({ lowercase, uppercase, numbers, symbols })) {
            if (include) alphabet += sets[key];
        }

        if (!alphabet) throw new Error("No character sets enabled.");

        // Build password body
        let password = "";
        for (let i = 0; i < length; i++) {
            password += alphabet[Math.floor(Math.random() * alphabet.length)];
        }

        // Apply guarantees
        let isValid = true;
        for (const [key, { include, guarantee }] of Object.entries({ lowercase, uppercase, numbers, symbols })) {
            if (include && guarantee && !password.split("").some(ch => sets[key].includes(ch))) {
                isValid = false;
                break;
            }
        }
        if (!isValid) {
            // regenerate if guarantees not met
            password = this.generatePassword(length, { lowercase, uppercase, numbers, symbols });
        }

        return password;
    }

}